import categories from '../../api/categories';
import * as types from '../mutation-types';
import _ from 'lodash';

const state = {
  categories: [],
  category: {}
};

const getters = {
  Categories: state => state.categories,
  SelectedCategory: state => state.category
};

const actions = {
  getCategories: ({ commit, state }) => {
    if (state.categories.length === 0) {
      categories.getCategories().then(response => {
        commit(types.SET_CATEGORIES, response.data);
        commit(types.SET_SELECTED_CATEGORY, response.data[0]);
      });
    }
  },

  selectCategory({ commit }, id) {
    const category = _.find(state.categories, category => category.id === id);
    commit(types.SET_SELECTED_CATEGORY, category);
  }
};

const mutations = {
  [types.SET_CATEGORIES](state, categories) {
    state.categories = categories;
  },

  [types.SET_SELECTED_CATEGORY](state, category) {
    state.category = category;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
